/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, MouseEventHandler } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';

const styles = css({
	width: '100%',
	minWidth: '0',
	height: '100%',
	objectFit: 'cover',
});

interface VideoProps {
	src: string;
	poster: string;
	onMouseEnter: MouseEventHandler<HTMLVideoElement>;
	onMouseLeave: MouseEventHandler<HTMLVideoElement>;
}

export const Video = forwardRef<HTMLVideoElement, VideoProps>(
	({ src, poster, onMouseEnter, onMouseLeave }, ref) => (
		<video
			ref={ref}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			css={styles}
			src={src}
			poster={poster}
			muted={true}
			preload="auto"
			playsInline={true}
		/>
	),
);
